import getValue from "utils/value-types/get-value/catalog-item";

export default function(value) {
  return getValue(value).records.reduce((counts, item) => {
    counts[item.id] = Number(item.quantity) + (counts[item.id] || 0);
    return counts;
  }, {});
}
